var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PersonList',{attrs:{"facility":_vm.facility},on:{"valid":function($event){return _vm.$emit('valid')},"not-valid":function($event){return _vm.$emit('not-valid')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }